import type { TypographyOptions } from '@mui/material/styles/createTypography';

export const typography = {
  fontFamily:
    '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji"',
  body1: { fontSize: '1rem', fontWeight: 400, lineHeight: 1.5 },
  body2: { fontSize: '0.875rem', fontWeight: 400, lineHeight: 1.57 },
  button: { fontSize: '0.875rem', fontWeight: 500, lineHeight: 1.2 },
  caption: { fontSize: '0.75rem', fontWeight: 500, lineHeight: 1.5 },
  subtitle1: { fontSize: '0.875rem', fontWeight: 600, lineHeight: 1.4 },
  subtitle2: { fontSize: '0.8125rem', fontWeight: 600, lineHeight: 1.4 },
  overline: {
    fontSize: '0.75rem',
    fontWeight: 500,
    letterSpacing: '0.5px',
    lineHeight: 2.5,
    textTransform: 'uppercase',
  },
  h1: {
    fontSize: '2.25rem',
    fontWeight: 700,
    letterSpacing: '-0.025em',
    lineHeight: 1.1,
  },
  h2: {
    fontSize: '1.875rem',
    fontWeight: 700,
    letterSpacing: '-0.025em',
    lineHeight: 1.15,
  },
  h3: {
    fontSize: '1.5rem',
    fontWeight: 600,
    letterSpacing: '-0.025em',
    lineHeight: 1.2,
  },
  h4: {
    fontSize: '1.25rem',
    fontWeight: 600,
    letterSpacing: '-0.02em',
    lineHeight: 1.3,
  },
  h5: {
    fontSize: '1.125rem',
    fontWeight: 600,
    letterSpacing: '-0.02em',
    lineHeight: 1.35,
  },
  h6: {
    fontSize: '1rem',
    fontWeight: 600,
    letterSpacing: '-0.01em',
    lineHeight: 1.4,
  },
} satisfies TypographyOptions;
